const baseUrlForTT = "https://tt.sunrise.staging.squaredev.io";
const baseUrlForRTM = "https://upm.sunrise.staging.squaredev.io";

const getOptions = (baseUrl, endPoint = "", parameters = {}) => {
  return {
    url: `${baseUrl}${endPoint}?` + new URLSearchParams(parameters).toString(),
    method: "GET",
    headers: {
      Authorization: `Bearer ${
        JSON.parse(sessionStorage.getItem("kc_tok"))
          ? JSON.parse(sessionStorage.getItem("kc_tok")).token
          : ""
      }`,
      "Content-Type": "application/json",
    },
  };
};

export { baseUrlForTT, baseUrlForRTM, getOptions };
